(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["solis-product-shortcuts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('solis-product-shortcuts')) {
    customElements.define('solis-product-shortcuts', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelectorAll('[data-product-jump]').forEach(link => {
          const destination = document.getElementById(link.dataset.productJump) || document.getElementById(link.dataset.productFallback);
          if (destination) link.setAttribute('href', '#' + destination.id);
          link.addEventListener('click', () => {
            const href = link.getAttribute('href');
            if (!href.startsWith('#')) return;
            const target = document.getElementById(href.slice(1));
            if (!target) return;
            const details = target.closest('details');
            if (details) {
              details.open = true;
              details.querySelector('summary')?.focus({ preventScroll: true });
            } else target.focus({ preventScroll: true });
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solis-pz-accessory-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('solis-accessory-picker')) {
    customElements.define('solis-accessory-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.items = Array.from(this.querySelectorAll('[data-accessory]'));
        this.selectedList = this.querySelector('[data-selected-list]');
        this.alternativeList = this.querySelector('[data-alternative-list]');
        this.dialog = this.querySelector('dialog');
        this.valueInput = this.querySelector('[data-accessory-value]');
        if (this.items.length !== 5 || !this.dialog || !this.valueInput) return;
        this.initialized = true;
        this.pending = null;
        this.selected = new Set(this.items.filter(item => item.dataset.selected === 'true').map(item => item.dataset.accessory));
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-swap')) this.openSwap(button.dataset.swap);
          if (button.hasAttribute('data-replace')) this.replace(button.dataset.replace);
          if (button.hasAttribute('data-cancel')) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.pending = null; });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        this.renderSelection();
      }
      renderSelection() {
        this.items.forEach(item => {
          const included = this.selected.has(item.dataset.accessory);
          item.dataset.selected = String(included);
          item.querySelector('[data-included]').hidden = !included;
          item.querySelector('[data-check]').hidden = !included;
          item.querySelector('[data-alternative]').hidden = included;
          item.querySelector('[data-swap]').hidden = included;
          (included ? this.selectedList : this.alternativeList).append(item);
        });
        this.valueInput.value = this.items.filter(item => this.selected.has(item.dataset.accessory)).map(item => item.dataset.value).join(', ');
      }
      openSwap(index) {
        if (this.selected.has(index) || !this.items[Number(index)] || this.dialog.open) return;
        this.pending = index;
        const name = this.items[Number(index)].dataset.label;
        const heading = this.dialog.querySelector('[data-dialog-title]');
        heading.textContent = this.dataset.includeLabel.replace('[accessory]', name);
        this.dialog.querySelectorAll('[data-choice]').forEach(choice => {
          const oldIndex = choice.dataset.choice;
          choice.hidden = !this.selected.has(oldIndex);
          choice.querySelector('button').setAttribute('aria-label', this.dataset.replaceLabel.replace('[accessory]', this.items[Number(oldIndex)].dataset.label).replace('[replacement]', name));
        });
        this.dialog.showModal();
        heading.focus();
      }
      replace(index) {
        if (!this.dialog.open || this.pending === null || !this.selected.has(index) || this.selected.has(this.pending)) return;
        const added = this.items[Number(this.pending)];
        const removed = this.items[Number(index)];
        this.selected.delete(index);
        this.selected.add(this.pending);
        this.renderSelection();
        this.dialog.close();
        this.pending = null;
        removed.querySelector('[data-swap]').focus();
        this.querySelector('[data-announcement-output]').textContent = this.dataset.announcement.replace('[accessory]', removed.dataset.label).replace('[replacement]', added.dataset.label);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
